import { Severity } from './ErrorLogger.types';

export const BI_ERRORS = {
  settings: {
    // last id 1001
    siteMediaTokenParse: {
      id: 1001,
      name: 'settings.siteMediaTokenParse',
      severity: Severity.FATAL,
    },
  },
  general: {
    // last id 1103
    image404: {
      id: 1100,
      name: 'general.image404',
    },
    chooseFile: {
      id: 1101,
      name: 'general.chooseFile',
    },
    failedTranslations: {
      id: 1102,
      name: 'general.failedTranslations',
    },
    unknown: {
      id: 1103,
      name: 'general.unknown',
    },
  },
  mediaManagerSDK: {
    // last id 1203
    listItems: {
      id: 1200,
      name: 'mediaManagerSDK.listItems',
    },
    uploadItem: {
      id: 1201,
      name: 'mediaManagerSDK.uploadItem',
    },
    mediaStudioUpload: {
      id: 1202,
      name: 'mediaManagerSDK.mediaStudioUpload',
    },
    addItemsToBoard: {
      id: 1203,
      name: 'mediaManagerSDK.addItemsToBoard',
    },
  },
};
